
import { Badge } from "@/components/ui/badge";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { Box, House, PanelsTopLeft, FileText, Settings } from "lucide-react";
import { ProjectVideo } from "@/components/ui/project-video";

// Define video URLs for each tab
const TAB_VIDEOS = {
  tab1: "https://files.catbox.moe/kn9lkt.mp4",
  tab2: "https://files.catbox.moe/pnjz89.mp4",
  tab3: "https://files.catbox.moe/61lbb3.mp4"
};
function TabsDemo() {
  return <div className="w-full py-[40px]">
      <div className="container mx-auto max-w-4xl">
        <Tabs defaultValue="tab-1" orientation="vertical" className="flex w-full gap-2">
          <TabsList className="flex-col">
            <TooltipProvider delayDuration={0}>
              <Tooltip>
                <TooltipTrigger asChild>
                  <span>
                    <TabsTrigger value="tab-1" className="py-3">
                      <House size={16} strokeWidth={2} aria-hidden="true" />
                    </TabsTrigger>
                  </span>
                </TooltipTrigger>
                <TooltipContent side="right" className="px-2 py-1 text-xs">
                  Dashboard
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
            <TooltipProvider delayDuration={0}>
              <Tooltip>
                <TooltipTrigger asChild>
                  <span>
                    <TabsTrigger value="tab-2" className="group py-3">
                      <span className="relative">
                        <FileText size={16} strokeWidth={2} aria-hidden="true" />
                        
                      </span>
                    </TabsTrigger>
                  </span>
                </TooltipTrigger>
                <TooltipContent side="right" className="px-2 py-1 text-xs">
                  Quotes
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
            <TooltipProvider delayDuration={0}>
              <Tooltip>
                <TooltipTrigger asChild>
                  <span>
                    <TabsTrigger value="tab-3" className="py-3">
                      <Settings size={16} strokeWidth={2} aria-hidden="true" />
                    </TabsTrigger>
                  </span>
                </TooltipTrigger>
                <TooltipContent side="right" className="px-2 py-1 text-xs">
                  Settings
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          </TabsList>
          <div className="grow rounded-lg border border-border text-start">
            <TabsContent value="tab-1" className="p-4 py-[5px] px-[5px]">
              <div className="relative rounded-2xl bg-zinc-50/40 p-1 ring-1 ring-zinc-200/50 ring-inset dark:bg-zinc-950/40 dark:ring-zinc-800/50 aspect-[1205/781] w-full max-h-[781px]">
                <ProjectVideo src={TAB_VIDEOS.tab1} title="Dashboard Video" />
              </div>
            </TabsContent>
            <TabsContent value="tab-2" className="p-4 py-[5px] px-[5px]">
              <div className="relative rounded-2xl bg-zinc-50/40 p-1 ring-1 ring-zinc-200/50 ring-inset dark:bg-zinc-950/40 dark:ring-zinc-800/50 aspect-[1205/781] w-full max-h-[781px]">
                <ProjectVideo src={TAB_VIDEOS.tab2} title="Quotes Video" />
              </div>
            </TabsContent>
            <TabsContent value="tab-3" className="p-4 py-[5px] px-[5px]">
              <div className="relative rounded-2xl bg-zinc-50/40 p-1 ring-1 ring-zinc-200/50 ring-inset dark:bg-zinc-950/40 dark:ring-zinc-800/50 aspect-[1205/781] w-full max-h-[781px]">
                <ProjectVideo src={TAB_VIDEOS.tab3} title="Settings Video" />
              </div>
            </TabsContent>
          </div>
        </Tabs>
      </div>
    </div>;
}
export { TabsDemo };
